import { Controller } from "@hotwired/stimulus"
import { logger } from "../utilities/logger"

// Handles copy-to-clipboard functionality
// Replaces: app/assets/javascripts/copy_link.js
export default class extends Controller {
  static values = {
    text: String  // Optional custom text to show after copy
  }

  // Prevent typing in the input
  preventEdit(event) {
    event.preventDefault()
  }

  // Double-click to copy
  copy(event) {
    const input = event.target
    const textToCopy = input.value

    // Copy to clipboard
    this.copyToClipboard(textToCopy)

    // Show confirmation if custom text provided
    if (this.hasTextValue) {
      const originalValue = input.value
      input.value = this.textValue
      setTimeout(() => {
        input.value = originalValue
      }, 1000)
    }
  }

  async copyToClipboard(text) {
    if (navigator.clipboard) {
      try {
        await navigator.clipboard.writeText(text)
      } catch (err) {
        this.fallbackCopy(text)
      }
    } else {
      this.fallbackCopy(text)
    }
  }

  fallbackCopy(text) {
    const textArea = document.createElement("textarea")
    textArea.value = text
    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()

    try {
      document.execCommand('copy')
    } catch (err) {
      logger.error('Copy failed:', err)
    }

    document.body.removeChild(textArea)
  }
}
